import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, Params, Data } from '@angular/router';
import { HandspraySeason, HandspraySiteOverview } from 'src/app/models/handspray.model';
import { MapMarker, MapInfoWindow } from '@angular/google-maps';

@Component({
    selector: 'app-handspray-map',
    templateUrl: './handspray-map.component.html',
    styleUrls: ['./handspray-map.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush // disable change detection for the benefit of agm-map
})
export class HandsprayMapComponent implements OnInit {

    @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow

    seasons: HandspraySeason[];
    selectedSeason: number = 0;
    sites: HandspraySiteOverview[];
    filteredSites: HandspraySiteOverview[];
    siteFilter: string;
    zoom = 7;
    center = {
        lat: 52.561928,
        lng: -1.464854,
    };

    selectedSite: HandspraySiteOverview = {
        id: 0,
        ref: '',
        latitude: 0,
        longitude: 0,
        address: '',
        status: '',
        is_vehicle_electric: false,
        visited: new Date()
    }

    constructor(
        private route: ActivatedRoute,
        private router: Router) { }

    ngOnInit() {
        this.route.params.subscribe((params: Params) => {
            if (params['season']) {
                this.selectedSeason = params['season'];
            } else {
                this.selectedSeason = 0;
            }
        });

        this.route.data.subscribe((data: Data) => {
            this.sites = data.sites;
            this.filteredSites = this.sites;
            this.seasons = data.seasons;
        });
    }

    onSeasonChange(newValue: number) {
        this.selectedSeason = newValue;
        this.router.navigate(['/handspray', 'map', newValue]);
    }

    matchesFilter(el: HandspraySiteOverview) {

        const haystack = (el.address + ' ' + el.ref).toLowerCase();

        if (haystack.includes(this.siteFilter.toLowerCase())) {
            return true;
        }

        return false;
    }

    onFilter() {
        if (this.siteFilter.length > 0) {
            this.filteredSites = this.sites.filter(this.matchesFilter, this);
        } else {
            this.filteredSites = this.sites;
        }
    }

    markerIcon(site: HandspraySiteOverview) {

        if (site.status == 'Completed' && site.is_vehicle_electric == true) {
            return '/assets/images/map-icons/completed_electric.png';
        }

        switch (site.status) {
            case 'Outstanding': return '/assets/images/map-icons/outstanding.png';
            case 'Completed': return '/assets/images/map-icons/completed.png';
            case 'Failed': return '/assets/images/map-icons/failed.png';
            default: return '/assets/images/map-icons/planned.png';
        }
    }

    showInfo(marker: MapMarker, site: HandspraySiteOverview) {

        if (site.id != this.selectedSite.id) {
            this.selectedSite = { ...site };
            this.info.open();
        } else {
            this.selectedSite.id = 0;
        }

    }

    onInfoClosed() {
        this.info.close();
        this.selectedSite.id = 0;
    }
}
